import { libertyLogoSrc } from "../../config/libertyBrand";

export default function LibertyBrandLogo({
  siteName = "Liberty",
  size = 40,
  showText = true,
  className = "",
  textClassName = "text-2xl font-bold",
}) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src={libertyLogoSrc}
        alt=""
        aria-hidden="true"
        className="rounded-2xl object-cover shadow-lg shadow-[#ff6b35]/25 ring-1 ring-[#ff6b35]/35"
        style={{ width: size, height: size }}
      />
      {showText ? (
        <span
          className={`${textClassName} bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a] bg-clip-text text-transparent`}
        >
          {siteName}
        </span>
      ) : null}
    </span>
  );
}
